import classNames from 'classnames';
import React, { Component } from 'react';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import './FileInputStyles.scss';
import { MAX_UPLOAD_FILE_COUNT, MAX_UPLOAD_FILE_SIZE } from '../../../configs';
import renderMessage from '../renderMessage';
import { required } from '../../../utils/validation';
import { intlShape } from '../../base/IntlProviderWrapper';
import { Icons } from '../../base/BootstrapComponents/BootstrapComponents';
import { metaDataFormatter } from '../../../utils/formatters';

class FileInput extends Component {
  state = {
    file: '',
    fileError: '',
  };

  componentDidMount() {
    this.setClear();
  }

  clearState = () => {
    this.setState({ file: '' });
  };

  setClear = () => {
    const { setClear = () => {} } = this.props;
    setClear(this.clearState);
  };

  onChange = event => {
    const {
      notSaveState = false,
      inputProps: {
        onChange = () => {},
        name = '',
      },
    } = this.props;
    const { formatMessage } = intlShape;
    const { files } = event.target;
    if (!files || !files.length) {
      return;
    }
    this.setState({ fileError: '' });

    if (files && files.length === 1) {
      this.setState({ file: files[0].name });
    }

    const result = [];
    for (let i = 0, len = files.length; i < len; i++) {
      const file = files[i];
      if (file.size > MAX_UPLOAD_FILE_SIZE) {
        this.setState({ fileError: formatMessage({ id: 'file.input.max.size' }, { name: file.name, size: MAX_UPLOAD_FILE_SIZE / 1024 / 1024 }) });
        continue;
      }
      result.push(file);
    }
    onChange(result);
    if (notSaveState) {
      event.target.value = '';
    }
  };

  renderLinkInput = () => {
    const { file, fileError } = this.state;
    const {
      label,
      placeholder = '',
      inputClassName = '',
      disabled = false,
      largeControl = false,
      readOnly = false,
      inputProps = {},
      dtoObject,
      fieldState = {
        error: '',
        touched: false,
      },
      // Это не криптография! Если ваш анализатор этого не понимает не используйте этот анализатор
      // nosemgrep
      controlId = `text-input-${Math.random() * 10000}`,
      multiple = false,
    } = this.props;
    const {
      error,
      isTouched: touched,
    } = fieldState;

    const isError = Boolean(error);
    const isRequired = dtoObject && dtoObject.validators && dtoObject.validators.length && !!dtoObject.validators.find(validator => validator.toString() === required.toString());
    return (
      <>
        <input
          type="file"
          className={classNames('form-file-input', inputClassName, { 'form-control-lg': largeControl }, { 'is-invalid': (isError && touched) || fileError })}
          id={controlId}
          aria-describedby={`${controlId}-help`}
          disabled={disabled}
          placeholder={placeholder}
          readOnly={readOnly}
          {...inputProps}
          onChange={this.onChange}
          multiple={multiple}
        />
        <label className="form-file-label" htmlFor={controlId}>
          <span className="form-file-button">
            {isRequired ? <span className="form-label-mark-required">*</span> : null}
            {file || renderMessage(label)}
          </span>
        </label>
      </>
    );
  };

  renderButtonInput = () => {
    const { file, fileError } = this.state;
    const {
      label,
      placeholder = '',
      inputClassName = '',
      disabled = false,
      largeControl = false,
      readOnly = false,
      inputProps = {},
      dtoObject,
      fieldState = {
        error: '',
        touched: false,
      },
      // Это не криптография! Если ваш анализатор этого не понимает не используйте этот анализатор
      // nosemgrep
      controlId = `text-input-${Math.random() * 10000}`,
      multiple = false,
    } = this.props;
    const {
      error,
      isTouched: touched,
    } = fieldState;
    const { name } = inputProps;
    const isError = Boolean(error);
    const isRequired = dtoObject && dtoObject.validators && dtoObject.validators.length && !!dtoObject.validators.find(validator => validator.toString() === required.toString());
    return (
      <>
        <input
          type="file"
          className={classNames('form-file-input', inputClassName, { 'form-control-lg': largeControl }, { 'is-invalid': (isError && touched) || fileError })}
          id={controlId}
          aria-describedby={`${controlId}-help`}
          disabled={disabled}
          placeholder={placeholder}
          readOnly={readOnly}
          name={name}
          multiple={multiple}
          onChange={this.onChange}
        />
        <label className="form-file-label" htmlFor={controlId}>
          <span className="form-file-button">
            {isRequired ? <span className="form-label-mark-required">*</span> : null}
            {file || renderMessage(label)}
          </span>
        </label>
      </>
    );
  };

  renderInput = () => {
    const { file, fileError } = this.state;
    const {
      label,
      placeholder = '',
      inputClassName = '',
      disabled = false,
      largeControl = false,
      readOnly = false,
      inputProps = {},
      dtoObject,
      fieldState = {
        error: '',
        touched: false,
      },
      // Это не криптография! Если ваш анализатор этого не понимает не используйте этот анализатор
      // nosemgrep
      controlId = `text-input-${Math.random() * 10000}`,
      multiple = false,
    } = this.props;
    const {
      error,
      isTouched: touched,
    } = fieldState;
    const isError = Boolean(error);
    const isRequired = dtoObject && dtoObject.validators && dtoObject.validators.length && !!dtoObject.validators.find(validator => validator.toString() === required.toString());
    return (
      <>
        <label htmlFor={controlId} className="form-label">
          <span className="form-file-button">
            {isRequired ? <span className="form-label-mark-required">*</span> : null}
            {renderMessage(label)}
          </span>
        </label>
        <input
          type="file"
          className={classNames('form-control', inputClassName, { 'form-control-lg': largeControl }, { 'is-invalid': (isError && touched) || fileError })}
          id={controlId}
          aria-describedby={`${controlId}-help`}
          disabled={disabled}
          placeholder={placeholder}
          readOnly={readOnly}
          {...inputProps}
          onChange={this.onChange}
          multiple={multiple}
        />
      </>
    );
  };

  renderMaterialInput = () => {
    const { file, fileError } = this.state;
    const {
      label,
      placeholder = '',
      inputClassName = '',
      disabled = false,
      largeControl = false,
      readOnly = false,
      inputProps = {},
      dtoObject,
      fieldState = {
        error: '',
        touched: false,
      },
      withLabel = true,
      // Это не криптография! Если ваш анализатор этого не понимает не используйте этот анализатор
      // nosemgrep
      controlId = `text-input-${Math.random() * 10000}`,
      multiple = false,
      formMeta,
    } = this.props;
    const { error } = fieldState;
    const { name } = inputProps;
    const isError = Boolean(error);
    const isRequired = dtoObject && dtoObject.validators && dtoObject.validators.length && !!dtoObject.validators.find(validator => validator.toString() === required.toString());
    return (
      <div className={classNames('input-block', { 'is-invalid': isError })}>
        {metaDataFormatter(formMeta, name || '', renderMessage(label))}
        <input
          type="file"
          className={classNames('form-control', inputClassName, { 'form-control-lg': largeControl }, { 'is-invalid': (isError) || fileError })}
          id={controlId}
          aria-describedby={`${controlId}-help`}
          disabled={disabled}
          placeholder={placeholder}
          readOnly={readOnly}
          name={name}
          multiple={multiple}
          onChange={this.onChange}
        />
        {withLabel ? (
          <div htmlFor={controlId} className="form-input-label">
            {isRequired ? <span className="form-label-mark-required">*</span> : null}
            {renderMessage(label)}
          </div>
        ) : null}
        <span className="input-after-block">
          <Icons width={16} height={16} customIcon icon="file" className="button-icons" />
        </span>
      </div>
    );
  };

  renderDefaultInput = () => {
    const { file, fileError } = this.state;
    const {
      label,
      placeholder = '',
      inputClassName = '',
      disabled = false,
      largeControl = false,
      readOnly = false,
      inputProps = {},
      dtoObject,
      fieldState = {
        error: '',
        touched: false,
      },
      hideButton = false,
      buttonContent = '',
      // Это не криптография! Если ваш анализатор этого не понимает не используйте этот анализатор
      // nosemgrep
      controlId = `text-input-${Math.random() * 10000}`,
      multiple = false,
    } = this.props;
    const {
      formatMessage,
    } = intlShape;
    const buttonContentText = buttonContent || formatMessage({ id: 'file.select' });
    const {
      error,
      isTouched: touched,
    } = fieldState;
    const isError = Boolean(error);
    const isRequired = dtoObject && dtoObject.validators && dtoObject.validators.length && !!dtoObject.validators.find(validator => validator.toString() === required.toString());
    return (
      <>
        <input
          type="file"
          className={classNames('form-file-input', inputClassName, { 'form-control-lg': largeControl }, { 'is-invalid': (isError && touched) || fileError })}
          id={controlId}
          aria-describedby={`${controlId}-help`}
          disabled={disabled}
          placeholder={placeholder}
          readOnly={readOnly}
          {...inputProps}
          onChange={this.onChange}
          multiple={multiple}
        />
        <label className="form-file-label" htmlFor={controlId}>
          <span className="form-file-text">
            {isRequired ? <span className="form-label-mark-required">*</span> : null}
            {file || renderMessage(label)}
          </span>
          {!hideButton ? <span className="form-file-button">{buttonContentText}</span> : null}
        </label>
      </>
    );
  };

  render() {
    const {
      className = '',
      textMuted = '',
      withLabel = false,
      withOutLabel = false,
      fieldState = {
        error: '',
        touched: false,
      },
      // Это не криптография! Если ваш анализатор этого не понимает не используйте этот анализатор
      // nosemgrep
      controlId = `text-input-${Math.random() * 10000}`,
      variant = 'default',
      outLabel = '',
      disabled,
    } = this.props;
    const { fileError } = this.state;
    const {
      error,
      isTouched: touched,
    } = fieldState;
    return (
      <>
        {withOutLabel ? <div className={classNames('form-out-label mt-label', { disabled, 'is-invalid': (error) || fileError })}>{renderMessage(outLabel)}</div> : null}
        <div className={classNames('form-control-wrapper', { material: variant === 'material' }, 'form-file', className, {
          'mt-label': withLabel && !withOutLabel, 'link-file-input': variant === 'link', 'button-file-input': variant === 'button', disabled, 'is-invalid': (error && touched) || fileError,
        })}
        >
          {variant === 'default' ? this.renderDefaultInput() : null}
          {variant === 'link' ? this.renderLinkInput() : null}
          {variant === 'button' ? this.renderButtonInput() : null}
          {variant === 'input' ? this.renderInput() : null}
          {variant === 'material' ? this.renderMaterialInput() : null}
          {textMuted ? <div id={`${controlId}-help`} className="form-text">{renderMessage(textMuted)}</div> : null}
          {error ? <div className="invalid-feedback">{renderMessage(error)}</div> : null}
          {fileError ? <div className="invalid-feedback">{fileError}</div> : null}
        </div>
      </>
    );
  }
}

export default compose(
  injectIntl,
)(FileInput);
